module.exports = __webpack_public_path__ + "static/media/ecommerce.21e8fff4.webp";